import {useState, useEffect, useCallback, createContext} from 'react';
import {useSnackbar} from "notistack";

const NoticeContext = createContext({});


export const NoticeProvider = ({children}) => {
    const [notices, setNotices] = useState({});
    const {enqueueSnackbar} = useSnackbar();

    const removeNotices = useCallback(() => {
        setNotices({});
    }, []);

    const removeNotice = useCallback((context, key) => {
        setNotices(prevNotices => {
            delete prevNotices[context][key];
            return {...prevNotices};
        })
    }, []);

    const addNotices = useCallback((notices, context) => {
        setNotices((prevNotices) => {
            const state = prevNotices[context] || {};
            for (const notice of notices) {
                if (!state[notice.type]) {
                    state[notice.type] = [];
                }
                state[notice.type] = [notice]
            }
            return {
                ...prevNotices,
                [context]: {
                    ...prevNotices[context],
                    ...state
                }
            }
        })
    }, []);

    const addNotice = useCallback((msg, context, type) => {
        if (Array.isArray(msg)) {
            const notices = msg;
            for (const notice of notices) {
                notice.type = type;
            }
            addNotices(notices, context);
        } else {
            const notice = {
                message: msg,
                type
            }
            addNotices([notice], context);
        }
    }, [addNotices]);

    const addErrorNotice = useCallback((msg, context = 'global') => {
        addNotice(msg, context, 'error');
    }, [addNotice]);

    const addSuccessNotice = useCallback((msg, context = 'global') => {
        addNotice(msg, context, 'success');
    }, [addNotice]);

    useEffect(() => {
        let search = window.location.search;
        if (search) {
            search = new URLSearchParams(search);
            if (search.has('error')) {
                addErrorNotice(search.get('error'));
            }
        }
    }, [addErrorNotice]);

    useEffect(() => {
        if (Object.keys(notices).length) {
            if (notices.global) {
                Object.keys(notices['global']).map(type => {
                    notices['global'][type].forEach((notice, idx) => {
                        enqueueSnackbar(notice.message, {
                            variant: notice.type,
                            onClose: () => {
                                removeNotice('global', notice.type)
                            }
                        });
                    })
                });
            }
        }
    }, [notices, removeNotice]);

    const context = {
        notices,
        hasNotices: Object.keys(notices).length > 0,
        addErrorNotice,
        addSuccessNotice,
        removeNotice,
        removeNotices
    }

    return <NoticeContext.Provider value={context}>{children}</NoticeContext.Provider>
}

export default NoticeProvider;

export {NoticeContext};